import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .FastFilters {
    display: grid;
    gap: 12px;
    position: relative;
    background: #f8faff;
    position: relative;
    grid-template-columns: repeat(auto-fit, 211px);

    @include respond-to(xs) {
      display: flex;
      flex-direction: column;
    }

    &--Closed {
      height: 106px;
      grid-row-gap: 90px;
      overflow: hidden;
    }
    &__Actions {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      padding-bottom: 4px;

      @include respond-to(xs) {
        width: 100%;
      }
    }
    &__SearchBtn,
    &__ResetBtn {
      height: 36px;
      padding: 0 20px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      border: none;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.85;
      }

      @include respond-to(xs) {
        flex: 1;
        height: 44px;
      }
    }
    &__SearchBtn {
      background: #3f51b5;
      color: #fff;
    }
    &__ResetBtn {
      background: #fff;
      color: #3f51b5;
      border: 1px solid #3f51b5;
    }
    &__OpenMoreFiltersButton {
      position: absolute;
      height: max-content;
      width: max-content;
      color: #0f0f0f;
      right: 16px;
      top: 78px;
      font-size: 12px;
      font-style: normal;
      font-weight: 300;
      line-height: 18px; /* 150% */
      text-decoration-line: underline;
    }
    &__OpenMoreFiltersButtonOpen {
      top: initial;
      bottom: 8px;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
